export enum OCULUS {
    NONE = 'NONE',
    OS = 'OS',
    OD = 'OD',
    OU = 'OU',
    ALT = 'ALT',
}
